var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CBadge',{attrs:{"color":_vm.getBadge(_vm.booleanValue)}},[_vm._v(" "+_vm._s(_vm.booleanValue ? 'Yes' : 'No')+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }